import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <div className="bg-red-900/30 border-b border-red-500/50 py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-xs md:text-sm text-red-300">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <p className="text-center">
          JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION. RETROUVEZ NOS CONSEILS SUR{' '}
          <a href="https://www.anj.fr" target="_blank" rel="noopener noreferrer" className="underline hover:text-red-200">
            ANJ
          </a>
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;

